import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import Loader from '@galo-monitor/web-components/Loader'
import Modal from '@galo-monitor/web-components/Modal'

const LoadingModal = ({ id, open }) => {
  const t = useT()

  return (
    <Modal
      id={ id }
      open={ open }
      escape={ false }
      hideHeader
    >
      <Loader message={ t('validating your data...') } />
    </Modal>
  )
}

LoadingModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired
}

export default LoadingModal
